import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { useQueryClient } from '@tanstack/react-query';
import { platform } from '@shared/lib/platform';
import { refreshAccessToken } from './useGuardTokenRefresh';

/** Resume from background: refresh JWT and invalidate active panic queries. */
export function useGuardLifecycle(): void {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!platform.isNative()) return;

    const sub = App.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) return;
      void refreshAccessToken().catch(() => undefined);
      void queryClient.invalidateQueries({ queryKey: ['panic', 'active'] });
    });

    return () => {
      void sub.then((h) => h.remove());
    };
  }, [queryClient]);
}
